<template>
  <div id="app-body-home">
    <!-- 顶栏 -->
    <HeaderMain></HeaderMain>
    <!-- 轮播图 -->
    <Carousel :img-list="imgList" :detail="true"></Carousel>
    <!-- 简介 -->
    <BriefIntroduction></BriefIntroduction>
    <!-- 开源课程 -->
    <NewClass></NewClass>
    <HotClass></HotClass>
    <!-- 开源课程 -->
    <EveryThing></EveryThing>
    <!-- 开源资产 -->
    <OpenAssets></OpenAssets>
    <!-- 开源资产 -->
    <BLTranslate></BLTranslate>
    <!-- 开源资产 -->
    <DiscussGroup></DiscussGroup>
    <!-- 页脚 -->
    <Footer></Footer>
  </div>
</template>

<script>

import Carousel from "@/views/share/Carousel";
import BriefIntroduction from "@/views/home/components/BriefIntroduction";
import NewClass from "@/views/home/components/NewClass";
import EveryThing from "@/views/home/components/EveryThing";
import OpenAssets from "@/views/home/components/OpenAssets";
import BLTranslate from "@/views/home/components/BLTranslate";
import DiscussGroup from "@/views/home/components/DiscussGroup";
import Footer from "@/views/home/components/Footer";
import HeaderMain from "@/views/share/HeaderMain";
import HotClass from "@/views/home/components/HotClass";

export default {
  name: "Home",
  components: {
    HotClass,
    HeaderMain,
    Footer,
    DiscussGroup,
    BLTranslate,
    OpenAssets,
    EveryThing,
    NewClass,
    BriefIntroduction,
    Carousel
  },
  data() {
    return {
      imgList: [
        {
          url: 'https://img.blendermagic.cn/new/homeCarousel1.png',
          toUrl: 'https://www.bilibili.com/video/BV1pV41127Dq/',
        },
        {
          url: 'https://img.blendermagic.cn/new/homeCarousel2.png',
          toUrl: 'https://www.bilibili.com/video/BV1h54y1y74K/',
        },
        {
          url: 'https://img.blendermagic.cn/new/homeCarousel3.png',
          toUrl: 'https://item.taobao.com/item.htm?id=606846162714',
        }
      ]
    }
  },
  mounted() {
    document.title = "斑斓魔法CG-专注于Blender的定时开源网站";
  }
}
</script>

<style scoped>

#app-body-home {
  min-width: 1260px;
  text-align: center;
}

</style>